import React, { useEffect } from 'react';
import { getBannerTargetWindow } from '../../data/sport-utils';
import { byRanking } from '../../data/utils';
import BannerOddsOverlay from './BannerOddsOverlay';

function handleOpenBanner(banner) {
    if (banner.avvData) {
        banner.avvData.openedFromBanner = true;
        localStorage.setItem('land-from-banner', JSON.stringify(banner.avvData));
    }
    window.open(banner.url,getBannerTargetWindow(banner.url));
}

function Carousel(props) {
    const indicators = [], banners = [];
    props.banners.sort(byRanking).forEach(function(banner, index) {
        const urlNotEmpty = banner.url != null && typeof banner.url === 'string' && banner.url.length > 0;
        const indicator = (
            <li key={banner.id} data-target="#carosello-sport-1" data-slide-to={`${index}`} className={`${index === 0 ? 'active' : ''}`}></li>
        );
        const item = (
            <div key={banner.id} className={`carousel-item${urlNotEmpty ? ' pointer' : ''}${index === 0 ? ' active' : ''}`} onClick={() => urlNotEmpty && handleOpenBanner(banner)}>
                <img className="d-block w-100" src={banner.imageUrl} alt=""></img>
                {banner.avvData != null &&
                    <BannerOddsOverlay banner={banner} />
                }
                {banner.avvData == null && banner.text?.length > 0 &&
                    <div className="banner-overlay">
                        <div className="banner-overlay-text-container">
                            <p className="banner-overlay-title">{banner.text}</p>
                        </div>
                    </div>
                }
            </div>
        );
        indicators.push(indicator);
        banners.push(item);
    });

    useEffect(() => {
        try {
            window.$('.carousel').carousel({
                interval: 3000,
                wrap: true
            });
        } catch (e) {
            console.error(e);
        }
    }, []);

    return (
        <div id="carosello-sport-1" className={"carousel slide"} data-ride="carousel">
            <ol className="carousel-indicators">
                {indicators}
            </ol>
            <div className="carousel-inner">
                {banners}
            </div>
        </div>
    );
}

export default Carousel;